import { ReactNode, createContext, useCallback, useContext, useRef, useState } from "react";

type HideOnScrollContextType = {
  scrollableElement?: HTMLElement | null;
  setScrollableElRef: (ref: HTMLElement | null) => void;
  isHideOnScrollContext: boolean;
  scrollToBottom: () => void;
};

const HideOnScrollContext = createContext<HideOnScrollContextType>({
  scrollableElement: undefined,
  setScrollableElRef: () => undefined,
  isHideOnScrollContext: false,
  scrollToBottom: () => undefined,
});

export const useHideOnScrollContext = () => useContext(HideOnScrollContext);

const HideOnScrollProvider = ({ children }: { children: ReactNode }) => {
  const [scrollableElement, setScrollableElement] = useState<HTMLElement | null>(null);
  const scrollableElementRef = useRef<HTMLElement | null>(null);

  const setScrollableElRef = useCallback((ref: HTMLElement | null) => {
    scrollableElementRef.current = ref;
    setScrollableElement(ref);
  }, []);

  const scrollToBottom = useCallback(() => {
    if (scrollableElementRef.current) {
      scrollableElementRef.current.scrollTop = scrollableElementRef.current.scrollHeight;
    }
  }, []);

  return (
    <HideOnScrollContext.Provider
      value={{
        scrollableElement,
        setScrollableElRef,
        isHideOnScrollContext: true,
        scrollToBottom,
      }}
    >
      {children}
    </HideOnScrollContext.Provider>
  );
};

export default HideOnScrollProvider;
